import React from "react";
import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const IMG_EMMA = "/amme/emma-bw-new.jpg";

export const Founder = ({ t }) => {
  return (
    <section
      data-testid="founder-section"
      className="relative bg-[#cececc] py-32 md:py-48 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-start">
          {/* Left — Emma photo */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-6"
          >
            <div className="aspect-[4/5] w-full overflow-hidden bg-stone-300">
              <img
                src={IMG_EMMA}
                alt="Emma at AMMÉ"
                className="w-full h-full object-cover"
                style={{ objectPosition: "center 25%" }}
              />
            </div>
            <p className="mt-6 text-[10px] uppercase tracking-[0.35em] text-stone-500">
              Emma · AMMÉ, Ubud
            </p>
          </motion.div>

          {/* Right — Emma bio */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-6 md:pt-8"
          >
            <p className="text-[11px] uppercase tracking-[0.4em] text-stone-500 mb-8">
              — {t.founder.label}
            </p>

            <h2 className="font-serif text-6xl md:text-7xl lg:text-8xl font-light leading-[0.9] text-stone-900 tracking-tight">
              {t.founder.name}
              <span className="italic text-[#3d3d3b]">.</span>
            </h2>

            <div className="mt-8 flex items-center gap-4">
              <div className="h-px w-12 bg-stone-500" />
              <div>
                <p className="text-[11px] uppercase tracking-[0.3em] text-stone-600">
                  {t.founder.role}
                </p>
                <a
                  href="https://www.instagram.com/emmamur"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="founder-instagram"
                  className="mt-1 inline-flex items-center gap-2 text-stone-800 hover:text-[#3d3d3b] transition-colors text-sm font-light"
                >
                  <Instagram size={13} strokeWidth={1.5} />
                  <span>{t.founder.handle}</span>
                </a>
              </div>
            </div>

            <p className="mt-12 font-serif italic text-2xl md:text-3xl leading-[1.3] text-stone-900">
              &ldquo;{t.founder.quote}&rdquo;
            </p>

            <div className="mt-10 space-y-5 text-stone-700 text-base md:text-lg font-light leading-[1.85] max-w-xl">
              <p>{t.founder.bio1}</p>
              <p>{t.founder.bio2}</p>
              <p>{t.founder.bio3}</p>
              {t.founder.bio4 && (
                <p className="italic text-stone-600">{t.founder.bio4}</p>
              )}
            </div>

            <p className="mt-10 font-serif italic text-xl text-stone-800">
              {t.founder.sign}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
